import React, { useContext } from "react";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import NemuruLogo from "./Logos/NemuruLogo";
import { customThemes } from "../../../../config/themes";
import CustomLogo from "./Logos/CustomLogo";
import { Box } from "@material-ui/core";

export default function Logo({ height, width, ...props }) {
  return (
    <Box
      height={height}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      {...props}
    >
      <ThemedLogo height={height} width={width} />
    </Box>
  );
}

const ThemedLogo = ({ height, width }) => {
  const {
    state: { themeName },
  } = useContext(ConfigContext);

  switch (themeName) {
    case customThemes.nemuru.themeName:
      return <NemuruLogo height={height} width={width} />;
    default:
      return <CustomLogo width={width} />;
  }
};
